import React, { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withStyles, Dialog } from "@material-ui/core";
import { withTranslation } from "react-i18next";
import {
  disableOtp,
  enableOtp,
  pushNotification,
  submitChangePassword,
  fillOtpEnabled,
  fillOtpDisabled,
} from "../../actions/index";
import { images } from "../../utils/images";
import { FileCopy } from "@material-ui/icons";
import QRCode from "qrcode.react";
import Loader from "../Loader";
import moment from "moment";

function Security(props) {
  const { classes, t, account, otpSecret, otpEnabled, otpDisabled } = props;
  const { otp } = account.account;
  const [otpModalOpen, setOtpModal] = useState(false);
  const [otpInput, setOtp] = useState("");
  const [changingPass, setChangingPass] = useState(false);
  const [oldPassword, setOldPass] = useState("");
  const [newPass, setNewPass] = useState("");
  const [newConfPass, setNewConfPass] = useState("");
  const [changePassBtnDisabled, setChangePassBtn] = useState(false);
  const [enablingOtpModal, setEnablingOtpModal] = useState(false);
  const [otpStep, changeOtpStep] = useState(1);

  const [passRequirements, showPassRequirements] = useState(false);
  const [passError, showPassError] = useState(false);
  const [notMatchingPasswords, setMatchingPasswords] = useState(false);
  const [isPasswordInvalid, setPasswordInvalid] = useState(false);

  const otpRef = useRef(null);

  useEffect(() => {
    if (!changingPass) {
      showPassRequirements(false);
      showPassError(false);
      setOtp("");
    }
  }, [changingPass]);

  const startOTPactivation = () => {
    setOtpModal(false);
    setEnablingOtpModal(true);
  };

  const disableOtp = () => {
    props.disableOtp(otpInput);
    // setTimeout(function () {
    //   setOtpModal(false);
    // }, 1000);
  };

  const continueOtp = () => {
    props.enableOtp({});

    changeOtpStep(2);
  };

  const finishOtpProcess = () => {
    changeOtpStep(3);
  };

  const confirmOtp = () => {
    props.enableOtp({ otp: otpInput });
    // changeOtpStep(1);
    // setEnablingOtpModal(false);
    setOtp("");
  };

  const cancelOtpEnabling = () => {
    setOtp("");
    setEnablingOtpModal(false);
    changeOtpStep(1);
  };

  useEffect(() => {
    if (otpEnabled) {
      setEnablingOtpModal(false);
      changeOtpStep(1);
      props.fillOtpEnabled(false);
    }
  }, [otpEnabled]);

  useEffect(() => {
    if (otpDisabled) {
      setOtpModal(false);
      setOtp("");
      props.fillOtpDisabled(false);
    }
  }, [otpDisabled]);

  const copyOtpSecret = (e) => {
    otpRef.current.select();
    document.execCommand("copy");
    e.target.focus();
    props.pushNotification({ message: "copyToClipboard", type: "info" });
  };

  const validatePasswords = () => {
    if (newPass === newConfPass) {
      setMatchingPasswords(false);
    } else {
      setMatchingPasswords(true);
    }
  };

  const validatePassRequirements = () => {
    var strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{6,})");

    if (strongRegex.test(newPass)) {
      showPassRequirements(false);
      showPassError(false);
    } else {
      showPassRequirements(false);
      showPassError(true);
    }
  };

  const changePassword = () => {
    let twoFactorPresent = otp ? (otpInput === "" ? false : true) : true;

    if (
      oldPassword === "" ||
      newPass === "" ||
      newConfPass === "" ||
      !twoFactorPresent
    ) {
      return pushNotification({ message: "missingIDFields", type: "error" });
    }

    props.submitChangePassword({
      current_password: oldPassword,
      new_password: newPass,
      otp: otp ? otpInput : null,
    });
  };

  return (
    <div className={classes.securityContainer}>
      <div className="securitySection">
        <h2>{t("security")}</h2>
        <div className="securityItem">
          <p>{t("password")}</p>
          <button onClick={() => setChangingPass(true)} className="securityBtn">
            {t("changePassword")}
          </button>
        </div>
        <div className="securityItem">
          <p>{t("twofactor")}</p>
          <button onClick={() => setOtpModal(true)} className="securityBtn">
            {otp ? t("disable") : t("enable")}
          </button>
        </div>
      </div>
      <div className="activitySection">
        <h2>{t("accActivity")}</h2>
        <div className="currentAct actSection">
          <h3>{t("currentSign")}</h3>
          <div className="actHeader">
            <p>{t("ipAddress")}</p>
            <p>{t("date")}</p>
            <p>{t("time")}</p>
          </div>
          <div className="actInfo">
            <p>{account.account.current_sign_in_ip}</p>
            <p>
              {moment(account.account.current_sign_in_at).format(
                "MMMM DD, YYYY"
              )}
            </p>
            <p>
              {moment(account.account.current_sign_in_at).format("HH:mm a z")}
            </p>
          </div>
        </div>
        {account.account.last_sign_in_at === "" ? (
          ""
        ) : (
          <div className="previousAct actSection">
            <h3>{t("previousSign")}</h3>
            <div className="actHeader">
              <p>{t("ipAddress")}</p>
              <p>{t("date")}</p>
              <p>{t("time")}</p>
            </div>
            <div className="actInfo">
              <p>{account.account.last_sign_in_ip}</p>
              <p>
                {moment(account.account.last_sign_in_at).format(
                  "MMMM DD, YYYY"
                )}
              </p>
              <p>
                {moment(account.account.last_sign_in_at).format("HH:mm A z")}
              </p>
            </div>
          </div>
        )}
        <p
          className="warning"
          dangerouslySetInnerHTML={{ __html: t("wrongActivity") }}
        />
      </div>
      <Dialog
        open={otpModalOpen}
        classes={{ paper: classes.modal }}
        scroll="body"
      >
        <div className="modalHeader">
          <p>{t("twofactor")}</p>
        </div>
        {otp ? (
          <div className="modalBody">
            <p>{t("disable2fa")}</p>
            <p>{t("typeToDisable")}</p>
            <input
              type="text"
              onChange={(e) => setOtp(e.target.value)}
              value={otpInput}
              maxLength={6}
              size={6}
              pattern="\d{6}"
              placeholder="XXXXXX"
              style={{
                width: 150,
                textAlign: "center",
                paddingLeft: 0,
                fontSize: 18,
                letterSpacing: "2px",
              }}
            />
            <div className="btns">
              <button className="cancelBtn" onClick={() => setOtpModal(false)}>
                {t("cancel")}
              </button>
              <button
                className="confirmBtn"
                disabled={otpInput === "" ? true : false}
                onClick={() => disableOtp()}
              >
                {t("disable")}
              </button>
            </div>
          </div>
        ) : (
          <div className="modalBody">
            <p>{t("warning")}</p>
            <p>{t("warningContent")}</p>
            <div className="btns">
              <button className="cancelBtn" onClick={() => setOtpModal(false)}>
                {t("doItLater")}
              </button>
              <button
                className="confirmBtn"
                onClick={() => startOTPactivation()}
              >
                {t("understand")}
              </button>
            </div>
          </div>
        )}
      </Dialog>
      <Dialog
        open={changingPass}
        classes={{ paper: classes.modal }}
        scroll="body"
      >
        <div className="modalHeader">
          <p>{t("changingPassword")}</p>
        </div>
        <div className="modalBody changingPassModal">
          <p className="warning">{t("_changinPasswordWarningLock")}</p>
          <input
            type="password"
            placeholder={t("oldPassword")}
            onChange={(e) => setOldPass(e.target.value)}
            value={oldPassword}
          />
          <input
            type="password"
            placeholder={t("newPassword")}
            onChange={(e) => setNewPass(e.target.value)}
            value={newPass}
            onFocus={() => {
              showPassRequirements(true);
              showPassError(false);
            }}
            onBlur={() => validatePassRequirements()}
            className={isPasswordInvalid || passError ? "invalidField" : ""}
          />
          <p
            className="passRequirements"
            style={
              passRequirements
                ? { height: "auto", marginBottom: 16, marginTop: 8 }
                : { height: 0, overflow: "hidden" }
            }
          >
            <img src={images.icons.lock} />
            {t("passRequirements")}
          </p>
          <p
            className="passRequirements notMatch"
            style={
              passError
                ? { height: "auto", marginBottom: 16, marginTop: 8 }
                : { height: 0, overflow: "hidden" }
            }
          >
            <img src={images.icons.error} />
            {t("passError")}
          </p>
          <input
            type="password"
            placeholder={t("confirmNewPassword")}
            onChange={(e) => setNewConfPass(e.target.value)}
            value={newConfPass}
            onBlur={() => validatePasswords()}
            className={notMatchingPasswords ? "invalidField" : ""}
          />
          {notMatchingPasswords ? (
            <p
              className="passRequirements notMatch"
              style={{ marginBottom: 16, marginTop: 8 }}
            >
              <img src={images.icons.error} />
              {t("passwordsDontMatch")}
            </p>
          ) : (
            ""
          )}
          {otp ? (
            <input
              type="text"
              placeholder={t("enterOtp")}
              onChange={(e) => setOtp(e.target.value)}
              value={otpInput}
            />
          ) : (
            ""
          )}
          <div className="btns">
            <button
              className="cancelBtn"
              onClick={() => setChangingPass(false)}
            >
              {t("cancel")}
            </button>
            <button
              className="confirmBtn passBtn"
              disabled={
                otp
                  ? newPass === "" ||
                    newConfPass === "" ||
                    oldPassword === "" ||
                    otp === ""
                    ? true
                    : false
                  : newPass === "" || newConfPass === "" || oldPassword === ""
                  ? true
                  : false
              }
              onClick={() => changePassword()}
            >
              {t("confirm")}
            </button>
          </div>
        </div>
      </Dialog>
      <Dialog
        open={enablingOtpModal}
        classes={{ paper: classes.modal }}
        scroll="body"
      >
        <div className="modalHeader">
          <p>{t("twofactor")}</p>
        </div>
        {otpStep === 1 ? (
          <div className="modalBody">
            <div className="stepModal">
              <p>{t("step1")}</p>
              <span>{t("downloadGoogle")}</span>
            </div>
            <div className="appBadges">
              <img src={images.logos.appleStore} />
              <img src={images.logos.googlePlay} />
            </div>
            <div className="stepModal">
              <p>{t("step2")}</p>
              <span>{t("clickYes")}</span>
            </div>
            <div className="stepModal">
              <p>{t("step3")}</p>
              <span>{t("scanCode")}</span>
            </div>
            <p className="note">{t("note")}</p>
            <div className="btns">
              <button
                className="cancelBtn"
                onClick={() => setEnablingOtpModal(false)}
              >
                {t("doItLater")}
              </button>
              <button className="confirmBtn" onClick={() => continueOtp()}>
                {t("imReady")}
              </button>
            </div>
          </div>
        ) : otpStep === 2 ? (
          <div className="modalBody">
            <p>{t("scanThis").toUpperCase()}</p>
            <div className="qrContainer">
              {otpSecret === null ? (
                ""
              ) : (
                <img
                  src={`${
                    (process.env.NODE_ENV === "production"
                      ? window.SOLO.env
                      : process.env
                    ).REACT_APP_QR
                  }?data=otpauth://totp/${
                    account.account.email
                  }?secret=${otpSecret}&issuer=CoinField&size=200`}
                />
              )}
            </div>
            <p className="writeCode">{t("writeThis").toUpperCase()}</p>
            <p className="note note2">{t("writeWarning")}</p>
            <div className="inputCode">
              <input
                type="text"
                readOnly
                value={otpSecret === null ? "" : otpSecret}
                ref={otpRef}
              />
              {document.queryCommandSupported("copy") && (
                <button onClick={(e) => copyOtpSecret(e)}>
                  <FileCopy /> {t("copyCode")}
                </button>
              )}
            </div>
            <div className="btns">
              <button className="confirmBtn" onClick={() => finishOtpProcess()}>
                {t("done")}
              </button>
            </div>
          </div>
        ) : (
          <div className="modalBody">
            <p>{t("typeToConfirmOtp")}</p>
            <input
              type="text"
              onChange={(e) => setOtp(e.target.value)}
              value={otpInput}
              maxLength={6}
              size={6}
              pattern="\d{6}"
              placeholder="XXXXXX"
              style={{
                width: 150,
                textAlign: "center",
                paddingLeft: 0,
                fontSize: 18,
                letterSpacing: "2px",
              }}
            />

            <div className="btns">
              <button className="cancelBtn" onClick={() => cancelOtpEnabling()}>
                {t("cancel")}
              </button>
              <button className="confirmBtn" onClick={() => confirmOtp()}>
                {t("confirm")}
              </button>
            </div>
          </div>
        )}
      </Dialog>
    </div>
  );
}

function mapStateToProps(state) {
  return {
    account: state.account,
    otpSecret: state.otpSecret,
    otpEnabled: state.otpEnabled,
    otpDisabled: state.otpDisabled,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      disableOtp,
      enableOtp,
      pushNotification,
      submitChangePassword,
      fillOtpEnabled,
      fillOtpDisabled,
    },
    dispatch
  );
}

const styles = (theme) => ({
  securityContainer: {
    // width: "100%",
    // maxWidth: 1100,

    "& .securitySection, & .activitySection": {
      background: theme.colors.background.fore,
      padding: "24px 40px",
      borderRadius: 4,
      marginBottom: 16,
      boxShadow: theme.defaults.shadow,
    },

    "& h2": {
      fontSize: 28,
      // fontFamily: "Titillium Web",
      fontWeight: 600,
      width: "100%",
      borderBottom: `1px solid ${theme.colors.misc.dividers}`,
      paddingBottom: 16,
      marginBottom: 16,
    },
    "& .securityItem": {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      margin: "16px 0",
      "& p": {
        fontWeight: 600,
        // fontFamily: "Titillium Web",
      },
      "& button": theme.defaults.roundBtn,
      "& .securityBtn": {
        background: "none",
        border: `1px solid ${theme.colors.buttons.green}`,
        color: theme.colors.buttons.green,
        width: 230,
        [theme.breakpoints.down(500)]: {
          width: 110,
          fontSize: 12,
        },
      },
    },
    "& .actSection": {
      // fontFamily: "Titillium Web",
      marginBottom: 16,

      "& h3": {
        fontSize: 20,
        marginBottom: 8,
        color: theme.colors.text.primary,
      },
      "& .actHeader, & .actInfo": {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        height: 32,

        "& p": {
          width: "32%",
          textAlign: "center",
        },
      },
      "& .actInfo": {
        height: 48,
        borderRadius: 4,
      },

      "&.currentAct": {
        "& .actInfo": {
          background: theme.colors.background.lightFore,
        },
      },
      "&.previousAct": {
        "& .actInfo": {
          border: `1px solid ${theme.colors.background.lightFore}`,
        },
      },
      [theme.breakpoints.down(875)]: {
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "space-between",
        "& h3": {
          width: "100%",
        },

        "& .actHeader": {
          width: "25%",
          display: "flex",
          flexDirection: "column",
          "& p": {
            width: "100% !important",
            marginTop: 8,
            marginBottom: 8,
            fontSize: 12,
          },
        },
        "& .actInfo": {
          width: "70%",
          display: "flex",
          flexDirection: "column",
          height: "auto",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          "& p": {
            width: "100% !important",
            marginTop: 8,
            marginBottom: 8,
            fontSize: 12,
          },
        },
      },
    },
    "& .warning": {
      marginTop: 32,
      // fontFamily: "Titillium Web",
      fontSize: 14,
      lineHeight: "21px",
      "& a": {
        ...theme.defaults.link,
      },
    },
  },
  modal: {
    background: theme.colors.background.fore,
    boxShadow: `0 2px 4px #D6D6D6`,
    borderRadius: 2,
    width: "95%",
    maxWidth: "700px !important",
    margin: 0,
    "& .modalHeader": {
      background: theme.colors.background.lightFore,
      boxShadow: `0 2px 4px #D6D6D6`,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      color: theme.colors.text.primary,
      fontWeight: 600,
      height: 75,
      fontSize: 18,
    },
    "& .modalBody": {
      padding: 32,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      "& .qrContainer": {
        display: "flex",
        justifyContent: "center",
        alignItem: "center",
        padding: 24,
        background: "white",

        "& img": {
          height: "auto",
          objectFit: "contain",
        },
      },
      "& p": {
        color: theme.colors.text.primary,
        marginBottom: 16,
        width: "70%",
        lineHeight: "21px",
        letterSpacing: ".8px",
        textAlign: "center",
      },
      "& input": {
        ...theme.defaults.input,
        marginTop: 8,
      },
      "& .appBadges": {
        display: "flex",
        justifyContent: "center",
        marginBottom: 16,
        "& img": {
          width: 110,
          margin: "0 8px",
          height: "auto",
          objectFit: "contain",
        },
      },
      "& .stepModal": {
        width: "100%",
        display: "flex",
        margin: "16px 0",
        "& p": {
          width: "20%",
          margin: 0,
          fontWeight: 600,
          textAlign: "left",
        },
        "& span": {
          color: theme.colors.text.secondary,
          width: "60%",
        },
      },
      "& .writeCode": {
        marginTop: 16,
        marginBottom: 0,
      },
      "& .note": {
        width: "100%",
        fontSize: 14,
        textAlign: "left",
        marginTop: 80,
        marginBottom: 0,
        "&.note2": {
          marginTop: 16,
          marginBottom: 16,
          textAlign: "center",
          maxWidth: 500,
          color: theme.colors.text.secondary,
        },
      },
      "& .inputCode": {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        "& input": {
          // width: "100%",
          marginTop: 0,
          maxWidth: 335,
        },
        "& button": {
          color: theme.colors.misc.blue,
          display: "flex",
          alignItems: "center",
          background: "none",
          transition: ".3s",
          cursor: "pointer",
          border: "none",
          marginLeft: 8,
          "&:hover": {
            opacity: 0.3,
          },
        },
      },
      "& .btns": {
        width: "100%",
        display: "flex",
        justifyContent: "flex-end",
        marginTop: 48,
        "& button": {
          ...theme.defaults.roundBtn,
          width: 150,
          textTransform: "capitalize",
        },
        "& .cancelBtn": {
          background: "none",
          border: `1px solid ${theme.colors.text.primary}`,
          color: theme.colors.text.primary,
          marginRight: 16,
        },
        "& .confirmBtn": {
          background: theme.colors.buttons.green,
          border: "1px solid transparent",
        },
        [theme.breakpoints.down(400)]: {
          justifyContent: "center",
        },
      },

      "&.changingPassModal": {
        paddingLeft: 80,
        paddingRight: 80,

        "& .warning": {
          color: theme.colors.misc.fail,
          textAlign: "center",
          width: "100%",
        },

        [theme.breakpoints.down(500)]: {
          paddingLeft: 24,
          paddingRight: 24,
        },

        "& input": {
          maxWidth: "none",
        },
      },
      "& .passRequirements": {
        fontSize: 14,
        // fontFamily: "Titillium Web",
        lineHeight: "21px",
        color: theme.colors.text.secondary,
        display: "flex",
        marginBottom: 0,
        width: "100%",
        textAlign: "left",
        "& img": {
          width: 12,
          height: 12,
          marginRight: 6,
          marginTop: 4,
        },

        "&.notMatch": {
          "& img": {
            width: 16,
            height: 16,
            marginRight: 6,
            marginTop: 0,
          },
        },
      },
    },
  },
});

export default withStyles(styles)(
  withTranslation()(connect(mapStateToProps, mapDispatchToProps)(Security))
);
